// @flow
import React from 'react';
import type { EventType } from 'types/Event';
import { getDateFromString, formatHours } from 'utils/dateUtils';
import { Link } from 'react-router-dom';

type Props = {
  event: EventType,
};

const EventListElement = (props: Props) => {
  const { event } = props;
  const startDate = getDateFromString(event.startDate);
  const endDate = getDateFromString(event.endDate);
  const adress = `${event.adress} ${event.zip} ${event.city}`;

  return (
    <div className="event__content">
      <h2 className="event__title ft-h4">
        <Link to={`/evenements/${event.slug}`} title={`Voir le détail de l'événement : ${event.title}`}>
          {event.title}
        </Link>
      </h2>
      <p>
        <span className="event__type ft-h6 ft-up">{props.event.tag || props.event.label}</span>
        {!event.all_day && (
          <span className="event__info">
            <i className="icon icon-clock is-inline" />
            {formatHours(startDate)}
            {startDate.getTime() !== endDate.getTime() && ` - ${formatHours(endDate)}`}
          </span>
        )}
        {event.adress && (
          <a href={`https://www.google.com/maps/search/${adress}`} target="__blank" className="event__info">
            <i className="icon icon-place is-inline" />
            {adress}
          </a>
        )}
      </p>
    </div>
  );
};

export default EventListElement;
